import React from 'react';
import PropTypes from 'prop-types';

const SearchInput = ({ placeholder, name, value, onChange, onClear }) => (
  <div className="c-search-input">
    <input className="c-input" type="text" placeholder={placeholder} value={value} onChange={onChange} name={name} />
    <button className="c-search-input__clear" type="button" display-if={value !== ''} onClick={onClear}>
      &times;
    </button>
  </div>
);

SearchInput.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

SearchInput.defaultProps = {
  placeholder: '',
  value: '',
  name: 'search',
};

export default SearchInput;
